<template>
  <div class="full-page text-center">
    <div class="content-error">
      <img :src="errorImage(error.statusCode)" />
      <q-spacer top="lg" />
      <q-text bold ink="midnight" variant="ui-baseline">
        Oops!<br />{{ error.messageErr ? error.messageErr : 'something wrong with the page' }}
        <q-spacer vertical="md">
          <q-button @click="refresh">{{ error.statusCode === 404 ? 'Go Home' : 'Reload' }}</q-button>
        </q-spacer>
      </q-text>
    </div>
  </div>
</template>

<script>
import { Spacer as QSpacer, Button as QButton, Text as QText } from '@qoala/ui';
import connImage from '@/assets/images/general/connection.png';
import errorImage from '@/assets/images/general/error-image.png';

export default {
  components: {
    QSpacer,
    QButton,
    QText
  },
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  methods: {
    refresh() {
      if (navigator.onLine && this.error.statusCode !== 404) {
        window.location.reload(true);
      }
      if (this.error.statusCode === 404) {
        this.$router.push(this.localePath('index'));
      }
    },
    errorImage(errorCode) {
      if (errorCode === 503 || errorCode === 444) {
        return connImage;
      }
      return errorImage;
    }
  }
};
</script>

<style lang="scss" scoped>
.content-error {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  padding: 0 15px;
  img {
    width: 30%;
  }
}

.volo-button.error {
  width: 60% !important;
}
</style>
